import { load } from 'recaptcha-v3';

export async function reCaptcha() {
  const recaptcha = await load(
    process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    {
      useRecaptchaNet: true,
      autoHideBadge: false,
      explicitRenderParameters: {
        badge: 'bottomleft',
      },
    },
  );
  const token = await recaptcha.execute('action');
  return token;
}

export function showReCaptcha() {
  const classBadge = 'grecaptcha-badge';
  const badge = document.querySelector(`.${classBadge}`);
  if (badge) badge.classList.remove('d-none');
  else reCaptcha();
}

export function hideReCaptcha() {
  const classBadge = 'grecaptcha-badge';
  const badge = document.querySelector(`.${classBadge}`);
  if (badge) badge.classList.add('d-none');
}
